import { useState, useCallback, FormEvent } from 'react';
import RangeSlider from 'react-bootstrap-range-slider';
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';

const LoanCalculator = () => {
  const [interest, setInterest] = useState(0);
  const [principal, setPrincipal] = useState<number>();
  const [repayment, setRepayment] = useState<number>();

  const [totalAmount, setTotalAmount] = useState(0);
  const [montlyPayment, setMontlyPayment] = useState(0);
  const [interestPaid, setInterestPaid] = useState(0);

  const onChangeInterestHandler = useCallback(
    (e: FormEvent<HTMLInputElement>) => {
      const interest = parseFloat(e.currentTarget.value);
      setInterest(interest);
      calculateLoan(principal!, interest, repayment!);
    },
    [principal, repayment]
  );

  const onChangeRepaymenttHandler = useCallback(
    (e: FormEvent<HTMLInputElement>) => {
      const repayment = parseInt(e.currentTarget.value);
      setRepayment(repayment);
      calculateLoan(principal!, interest, repayment);
    },
    [principal, interest]
  );

  const onChangePrincipalHandler = useCallback(
    (e: FormEvent<HTMLInputElement>) => {
      const principal = parseInt(e.currentTarget.value);
      setPrincipal(principal);
      calculateLoan(principal, interest, repayment!);
    },
    [repayment, interest]
  );

  const calculateLoan = (principal: number, interest: number, repayment: number) => {
    if (principal && repayment) {
      const calculateInterestPaid = (principal * interest * (repayment / 12)) / 100;
      const calculateTotalAmountPaid = principal + calculateInterestPaid;
      setInterestPaid(calculateInterestPaid);
      setTotalAmount(calculateTotalAmountPaid);
      setMontlyPayment(Math.ceil(calculateTotalAmountPaid / repayment));
    }
  };

  return (
    <div className='card bg-dark hoverable card-xl-stretch mb-xl-8'>
      <div className='card-body'>
        <h3 className='text-white pb-3 '>Loan Calculator</h3>
        <p className='text-white pb-4'>Enter the loan amount, repayment period and interest rate</p>

        <div className='mb-5 col-lg-12'>
          <label className='form-label text-white fs-8'>Loan Amount</label>
          <div className='mb-3'>
            <input type='number' name='project_name' className='form-control  form-control-solid' value={principal} onChange={onChangePrincipalHandler} />
          </div>
        </div>

        <div className='mb-5 col-lg-12'>
          <label className='form-label text-white fs-8'>Repayment Period (in months)</label>
          <div className='mb-3'>
            <input type='number' name='project_name' className='form-control  form-control-solid' value={repayment} onChange={onChangeRepaymenttHandler} />
          </div>
        </div>

        <div className='mb-5 col-lg-12'>
          <label className='form-label text-white fs-8'>Interest Rate</label>
          <div className='mb-3'>
            <RangeSlider value={interest} onChange={onChangeInterestHandler} tooltipLabel={(value) => `${value}%`} tooltip='on' min={0} max={100} step={0.5} className='d-block full-width' variant='warning' />
          </div>
        </div>

        {principal && repayment && interest !== 0 ? (
          <div className='text-white mt-15'>
            <div className='text-center'>
              <label className='text-white fs-8'>Total Amount</label>
              <h1 className='text-white'>{totalAmount.toLocaleString()}</h1>
            </div>

            <div className='d-flex justify-content-between mt-10'>
              <div>
                <label className='text-white fs-8'>Interest Paid</label>
                <h3 className='text-white'>{interestPaid.toLocaleString()}</h3>
              </div>

              <div>
                <label className='text-white fs-8'>Montly Payment</label>
                <h3 className='text-white'>{montlyPayment.toLocaleString()}</h3>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default LoanCalculator;
